// extracted by mini-css-extract-plugin
module.exports = {"Matches__matches__2j9Nv":"Matches__matches__2j9Nv","Matches__tabs__6l8WM":"Matches__tabs__6l8WM","Matches__tab-content__PpdB1":"Matches__tab-content__PpdB1"};